import { Component, ElementRef, input, output, viewChild } from '@angular/core';
import { SynRadioComponent, SynRadioGroupComponent } from '@synergy-design-system/angular';

export interface ToggleGroupOption<T extends string = string> {
  displayText: string;
  value: T;
}

@Component({
  selector: 'app-toggle-group',
  template: `
    <syn-radio-group
      [value]="value()"
      [size]="'medium'"
      [required]="true"
      (synChangeEvent)="onValueChange($event)"
      class="container"
      #radioGroup
    >
      @for (option of options(); track option.value) {
        <syn-radio [value]="option.value">{{ option.displayText }}</syn-radio>
      }
    </syn-radio-group>
  `,
  styles: [],
  imports: [SynRadioGroupComponent, SynRadioComponent],
})
export class ToggleGroupComponent<T extends string = string> {
  options = input<ToggleGroupOption<T>[]>([]);
  value = input.required<T>();
  disabled = input(false);
  select = output<T>();

  child = viewChild.required<ElementRef<HTMLInputElement>>('radioGroup');

  onValueChange(event: Event) {
    if (event.target === this.child().nativeElement) {
      const value: T = this.child().nativeElement.value as T;
      this.select.emit(value);
    }
  }
}
